import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

type Options = {
  param: string
  when?: string
  onMatch?: () => void
}

/**
 * If param === when, call onMatch() and then remove param from the URL.
 */
export function useConsumeQueryParam({ param, when, onMatch }: Options) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const value = searchParams?.get(param)

    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (value === null || (when !== undefined && value !== when) || !pathname) return

    onMatch?.()

    const params = new URLSearchParams(searchParams ?? {})
    params.delete(param)

    router.replace(params.size > 0 ? `${pathname}?${params}` : pathname, {
      scroll: false,
    })
  }, [param, when, onMatch, router, pathname, searchParams])
}
